import { useAuthStore } from '@/stores/auth';
import axios from 'axios';

const api = axios.create({
  // baseURL: 'https://nuvem.gaviinfo.com.br/rn-573-backend',
  // baseURL: 'http://localhost/rn-573/api/',
  baseURL: 'https://apasaps.gavisaude.com.br/api/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('rn573_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor de resposta: tratamento de erros e logout automático
api.interceptors.response.use(
  response => response,
  async error => {
    const status = error.response?.status;

    // Se token expirou ou é inválido
    if (status === 401 && error.config && !error.config._isRetry) {
      error.config._isRetry = true;
      try {
        const authStore = useAuthStore();
        await authStore.refreshToken();
        const token = localStorage.getItem("rn573_access_token");
        error.config.headers.Authorization = `Bearer ${token}`;
        return api(error.config);
      } catch (refreshError) {
        const store = useAuthStore();
        store.logout();
        return Promise.reject("Sessão expirada. Faça login novamente.");
      }
    }

    // Mensagens específicas por status
    let mensagem = 'Erro inesperado. Tente novamente.';

    if (error.response) {
      const data = error.response.data;
      if (data?.message) {
        mensagem = data.message;
      } else if (status === 404) {
        mensagem = 'Recurso não encontrado.';
      } else if (status === 500) {
        mensagem = 'Erro interno do servidor.';
      }
    } else if (error.request) {
      mensagem = 'Não foi possível conectar ao servidor.';
    }

    return Promise.reject(mensagem);
  }
);

export default api;
